"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackClickBookingTextLink = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackClickBookingTextLink(clickText, clickUrl, clickElement) {
    const bookingEvent = {
        event: 'JS_Event',
        eventData: {
            eventName: enums_1.GA4EventName.ClickTextLink,
            feature_category: enums_1.GA4FeatureCategory.DirectBooking,
            click_element: clickElement,
            click_text: clickText,
            click_url: clickUrl,
        },
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)(bookingEvent);
}
exports.trackClickBookingTextLink = trackClickBookingTextLink;
//# sourceMappingURL=trackClickBookingTextLink.js.map